export const GET_USER_ALLOCATED_NUMBERS = "GET_USER_ALLOCATED_NUMBERS";
export const GET_AVAILABLE_NUMBERS = "GET_AVAILABLE_NUMBERS";
export const ASSIGN_NUMBER = "ASSIGN_NUMBER";